import BasicRepository from "./basicRepository";
import Client from "../client";
import { WorkerPoolResource, WorkerPoolsSummaryResource, ResourceCollection, WorkerMachineResource } from "client/resources";
import { WorkerPoolsSupportedTypes, DynamicWorkerType } from "client/resources/workerPoolsSupportedTypesResouce";

class WorkerPoolRepository extends BasicRepository<WorkerPoolResource, WorkerPoolResource> {
    constructor(client: Client) {
        super("WorkerPools", client);
    }
    machines(workerPool: WorkerPoolResource, args?: Partial<WorkerPoolsMachinesArgs>): Promise<ResourceCollection<WorkerMachineResource>> {
        return this.client.get<ResourceCollection<WorkerMachineResource>>(workerPool.Links["Workers"], args);
    }
    summary(args?: Partial<WorkerPoolsSummaryArgs>) {
        return this.client.get<WorkerPoolsSummaryResource>(this.client.getLink("WorkerPoolsSummary"), args);
    }
    sort(order: string[]) {
        return this.client.put(this.client.getLink("WorkerPoolsSortOrder"), order);
    }
    getSupportedPoolTypes() {
        return this.client.get<WorkerPoolsSupportedTypes>(this.client.getLink("WorkerPoolsSupportedTypes"));
    }
    async getDynamicWorkerTypes() {
        const resultPromise = this.client.get<{ id: string; WorkerTypes: DynamicWorkerType[] }>(this.client.getLink("WorkerPoolsDynamicWorkerTypes"));
        const result = await resultPromise;
        return result.WorkerTypes;
    }
}

export type WorkerPoolsMachinesArgs = {
    skip: number;
    take: number;
    partialName: string;
    isDisabled: boolean;
    healthStatuses: string;
    commStyles: string;
    shellNames: string;
};

export type WorkerPoolsSummaryArgs = {
    ids: string;
    partialName: string;
    machinePartialName: string;
    isDisabled: boolean;
    healthStatuses: string;
    commStyles: string;
    hideEmptyWorkerPools: boolean;
    shellNames: string;
};

export default WorkerPoolRepository;
